/**
 * Mount redeem widgets. Cart/drawer HTML may remorph after points change,
 * so we rebind whenever new [data-points-redeem] nodes appear.
 */
(function () {
  if (window.__gltheaaPointsRedeem) return;
  window.__gltheaaPointsRedeem = true;

  function formatApplied(root, points, discountAmount) {
    const msgApplied = root.dataset.msgApplied || "Applied {{ points }} pt (−{{ money }})";
    const currencyCode = (root.dataset.currency || "USD").toUpperCase();
    let money;
    try {
      money = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode,
        currencyDisplay: "narrowSymbol",
      }).format(Number(discountAmount) || 0);
    } catch (_e) {
      money = currencyCode + " " + discountAmount;
    }
    return msgApplied
      .replaceAll("{{ points }}", String(points))
      .replaceAll("{{ money }}", money)
      .replaceAll("{{ amount }}", money)
      .replaceAll("%{points}", String(points))
      .replaceAll("%{money}", money);
  }

  function mount(root) {
    if (!(root instanceof HTMLElement) || root.dataset.pointsBound === "1") return;
    root.dataset.pointsBound = "1";

    const proxyUrl = root.dataset.proxyUrl;
    const balanceEl = root.querySelector("[data-points-balance]");
    const balanceValueEl = root.querySelector("[data-points-balance-value]");
    const appliedEl = root.querySelector("[data-points-applied]");
    const form = root.querySelector("[data-points-form]");
    const input = root.querySelector("[data-points-input]");
    const clearButton = root.querySelector("[data-points-clear]");
    const messageEl = root.querySelector("[data-points-message]");
    const appliedPoints = Number(root.dataset.appliedPoints || "0");
    const msgCleared = root.dataset.msgCleared || "Cleared";
    const msgError = root.dataset.msgError || "Request failed";

    function showMessage(text, tone) {
      if (!messageEl) return;
      messageEl.textContent = text;
      messageEl.hidden = !text;
      messageEl.dataset.tone = tone || "";
    }

    function updateAddonStatus(points) {
      const status = root
        .closest("[data-gltheaa-cart-addon]")
        ?.querySelector("[data-gltheaa-points-status]");
      if (!status) return;
      const unit = root.dataset.pointsUnit || "pt";
      if (points > 0) {
        status.hidden = false;
        status.textContent = String(points) + " " + unit;
      } else {
        status.hidden = true;
        status.textContent = "";
      }
    }

    function updateAppliedState(points, discountAmount) {
      updateAddonStatus(points);
      if (!appliedEl || !clearButton) return;
      if (points > 0) {
        appliedEl.hidden = false;
        appliedEl.textContent = formatApplied(root, points, discountAmount);
        clearButton.hidden = false;
        if (input) input.value = String(points);
      } else {
        appliedEl.hidden = true;
        appliedEl.textContent = "";
        clearButton.hidden = true;
        if (input) input.value = "";
      }
    }

    async function request(points) {
      const url = new URL(proxyUrl, window.location.origin);
      if (points !== undefined) {
        url.searchParams.set("points", String(points));
      }
      const response = await fetch(url.toString(), {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || msgError);
      }
      return data;
    }

    function updateBalanceDisplay(data) {
      const available = data.availablePoints ?? data.balance ?? 0;
      if (balanceValueEl) balanceValueEl.textContent = String(available);
      if (balanceEl) balanceEl.hidden = false;
      if (input) {
        const maxLock = available + (data.appliedPoints ?? 0);
        input.max = String(maxLock);
      }
    }

    form?.addEventListener("submit", async (event) => {
      event.preventDefault();
      showMessage("", "");
      const points = Number(input?.value || "0");
      try {
        const data = await request(points);
        updateBalanceDisplay(data);
        updateAppliedState(data.appliedPoints, data.discountAmount);
        showMessage(
          data.message || formatApplied(root, data.appliedPoints, data.discountAmount),
          "success",
        );
        if (window.PointsCartRefresh) {
          await window.PointsCartRefresh.afterRedeemChange();
        }
      } catch (error) {
        showMessage(error.message, "error");
      }
    });

    clearButton?.addEventListener("click", async () => {
      showMessage("", "");
      try {
        const data = await request(0);
        updateBalanceDisplay(data);
        updateAppliedState(0, 0);
        showMessage(data.message || msgCleared, "success");
        if (window.PointsCartRefresh) {
          await window.PointsCartRefresh.afterRedeemChange();
        }
      } catch (error) {
        showMessage(error.message, "error");
      }
    });

    request()
      .then((data) => {
        updateBalanceDisplay(data);
        updateAppliedState(data.appliedPoints ?? 0, data.discountAmount ?? 0);
      })
      .catch((error) => showMessage(error.message, "error"));

    if (appliedPoints > 0) {
      updateAppliedState(appliedPoints, 0);
    }
  }

  function scan() {
    document.querySelectorAll("[data-points-redeem]").forEach(mount);
  }

  scan();
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
